import ClassAChecks from './ClassAChecks';

export default ClassAChecks;